import React, { useEffect, useState } from 'react';
import { Table, Card, Row, Col } from 'react-bootstrap';
import { getSurveyResponses } from 'services/reports';
import PropTypes from 'prop-types';

const ResponsesTablePdf = ({ surveyId }) => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setResponses([]);

    getSurveyResponses(surveyId)
      .then(response => {
        if (isMounted) {
          setResponses(response.result ? response.data : []);
        }
      })
      .catch(() => {
        if (isMounted) setResponses([]);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [surveyId]);

  return (
    <Row className="g-3 mb-2">
      <Col xs={12}>
        <Card className="mb-3">
          <Card.Header>
            <h5 className="mb-0 text-center text-md-start">
              Listado de respuestas recibidas
            </h5>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
              </div>
            ) : responses.length === 0 ? (
              <div className="text-center py-3 text-muted">
                No hay respuestas disponibles para esta encuesta.
              </div>
            ) : (
              <Table
                striped
                bordered
                size="sm"
                className="mb-0"
                style={{
                  borderWidth: 1,
                  borderColor: '#343a40',
                  borderStyle: 'solid',
                  fontSize: 12
                }}
              >
                <thead>
                  <tr>
                    <th>IP del Usuario</th>
                    <th>Fecha y hora en que el usuario contestó</th>
                  </tr>
                </thead>
                <tbody>
                  {responses.map(resp => (
                    <tr key={resp.id}>
                      <td>{resp.user_ip}</td>
                      <td>{resp.created_at}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

ResponsesTablePdf.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ResponsesTablePdf;
